import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail, MapPin, Building2, Instagram, Facebook } from "lucide-react";
import { COMPANY, waLink, telLink } from "../lib/config";

export const Footer = () => (
  <footer data-testid="footer" className="bg-slate-900 text-slate-300 mt-20">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center">
              <Building2 className="w-5 h-5 text-white" />
            </div>
            <div>
              <div className="font-display text-xl text-white">SANTRAL EMLAK LTD</div>
              <div className="text-[10px] tracking-[0.28em] uppercase text-slate-400">31+ Yıl Kesintisiz Güven</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-slate-400 max-w-md">
            Türkiye’nin tüm il ve ilçelerinde satılık ve kiralık gayrimenkul çözümleri.
            Yetki Belgesi No: <span className="text-slate-200">{COMPANY.license}</span>
          </p>
          <div className="flex gap-3 mt-6">
            <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors"><Instagram className="w-4 h-4" /></a>
            <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors"><Facebook className="w-4 h-4" /></a>
            <a href={waLink()} aria-label="WhatsApp" className="w-10 h-10 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors"><MessageCircle className="w-4 h-4" /></a>
          </div>
        </div>

        <div className="md:col-span-3">
          <div className="label-caps text-slate-400 mb-4">Hızlı Bağlantılar</div>
          <ul className="space-y-3 text-sm">
            <li><Link to="/" className="hover:text-white transition-colors">Ana Sayfa</Link></li>
            <li><Link to="/ilanlar?islem=satilik" className="hover:text-white transition-colors">Satılık</Link></li>
            <li><Link to="/ilanlar?islem=kiralik" className="hover:text-white transition-colors">Kiralık</Link></li>
            <li><Link to="/hakkimizda" className="hover:text-white transition-colors">Hakkımızda</Link></li>
            <li><Link to="/iletisim" className="hover:text-white transition-colors">İletişim</Link></li>
          </ul>
        </div>

        <div className="md:col-span-4">
          <div className="label-caps text-slate-400 mb-4">İletişim</div>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3"><MapPin className="w-4 h-4 mt-0.5 shrink-0 text-[#C0562F]" /><span className="text-slate-300">{COMPANY.address}</span></li>
            <li className="flex items-center gap-3"><Phone className="w-4 h-4 text-[#C0562F]" /><a href={telLink()} className="hover:text-white">{COMPANY.phone}</a></li>
            <li className="flex items-center gap-3"><MessageCircle className="w-4 h-4 text-[#C0562F]" /><a href={waLink()} className="hover:text-white">{COMPANY.whatsapp}</a></li>
            <li className="flex items-center gap-3"><Mail className="w-4 h-4 text-[#C0562F]" /><a href={`mailto:${COMPANY.email}`} className="hover:text-white">{COMPANY.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 mt-16 pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-slate-500">
        <div>© 2026 SANTRAL EMLAK LTD. Tüm hakları saklıdır.</div>
        <div>Yetki Belgesi No: {COMPANY.license}</div>
      </div>
    </div>
  </footer>
);
